module.exports = __webpack_public_path__ + "static/carlet2024-2f61271b2ba75742843093660bb71cd3.png";